import React, { useEffect, useState } from "react";

import ViewPDF from "@/components/ViewPDF";
import styles from "@/pages/ViewPledgeTicket/ViewPledgeTicket.module.css";
import { getPledgeTicketPreview } from "@/services/Pledge/PledgeApis";
import { usePledgesStore } from "@/stores/usePledgesStore";

const ViewPledgeTicket: React.FC = () => {
  const { pledges } = usePledgesStore();

  const [ticketPdfUrl, setTicketPdfUrl] = useState<string | null>(null);

  const getPledgeTicketPreviewHelper = async (): Promise<void> => {
    if (!pledges?.[0]?.id) {
      return;
    }

    try {
      const response = await getPledgeTicketPreview(pledges?.[0]?.id, {
        is_customer: true,
      });

      const pdfBlob = new Blob([response], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);

      setTicketPdfUrl(`${pdfUrl}#toolbar=1&navpanes=0&scrollbar=1`);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    void getPledgeTicketPreviewHelper();

    return (): void => {
      if (ticketPdfUrl) {
        URL.revokeObjectURL(ticketPdfUrl);
      }
    };
  }, []);

  return (
    <div className={styles.mainContainer}>
      {/* <div className={styles.headerSection}>Ticket Details</div> */}
      <span className={styles.title}>Ticket Details</span>
      <div className={styles.bodySection}>
        <div className={styles.pdfViewer}>
          <ViewPDF pdfUrl={ticketPdfUrl ?? ""} height="700px" />
        </div>
      </div>
    </div>
  );
};

export default ViewPledgeTicket;
